import { render, staticRenderFns } from "./CurrencyActivationDescription.vue?vue&type=template&id=2c08d344&"
import script from "./CurrencyActivationDescription.vue?vue&type=script&lang=js&"
export * from "./CurrencyActivationDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports